import React, {useState} from 'react';
import { UncontrolledTooltip } from "reactstrap";
import UploadGalleryModal from "../../../../components/uploadgallery/UploadGalleryModal";
import reviewBuilderGalleryApi from "../../../../components/uploadgallery/reviewBuilderGalleryApi";

function BulkLocationEditorFacebook ({
                                       singleLocationMode,
                                       locationPatch,
                                       mergeIntoLocationPatch
}) {

  const [imageSelectorOpen, setImageSelectorOpen] = useState(false);

  const setCoverPhotoUrl = (imageUrl) => {
    mergeIntoLocationPatch({
      "facebookListingManagementSpecs": {
        "coverPhotoUrl": imageUrl
      }
    });
    setImageSelectorOpen(false);
  };

  const unsetCoverPhotoUrl = () => {
    mergeIntoLocationPatch({
      "facebookListingManagementSpecs": {
        "coverPhotoUrl": null
      }
    })
  };

  const aboutChange = (e) => {
    const about = e.target.value;
    if (about === "") {
      mergeIntoLocationPatch({
        "facebookListingManagementSpecs": {
          "about": null
        }
      })
    } else {
      mergeIntoLocationPatch({
        "facebookListingManagementSpecs": {
          "about": about
        }
      })
    }
  };

  const setTrackingNumber = (e) => {
    const trackingNumber = e.target.value;
    mergeIntoLocationPatch({
      "listingManagementSpecs": {
        "providerTrackingNumbers": {
          "FACEBOOK": trackingNumber
        }
      }
    })
  };

  const setTrackingUrl = (e) => {
    const trackingUrl = e.target.value;
    mergeIntoLocationPatch({
      "listingManagementSpecs": {
        "providerTrackingWebsiteUrls": {
          "FACEBOOK": trackingUrl
        }
      }
    })
  };

  return <div className="card-spacer-top card-spacer-bottom">

    <h5 className="content-spacer-top">About</h5>
    <div className="row card-spacer-top">
      <div className="col-12">
        <textarea
          id="facebookAbout"
          placeholder='A description of your business for the Facebook "About" section of a listing. 155 character maximum.'
          maxLength={155}
          value={locationPatch.facebookListingManagementSpecs.about}
          onChange={aboutChange}
          className="form-control text-input"
        />
        <small className="pull-right ng-binding">{!!locationPatch.facebookListingManagementSpecs.about ? <span>{locationPatch.facebookListingManagementSpecs.about.length}</span> : <span style={{"display": "block", opacity: "0"}}>line spacer</span>}</small>
      </div>
    </div>

    <h5 className="content-spacer-top">Call Tracking Number</h5>
    <div className="row card-spacer-top">
      <div className="col-12">
        <input
          type="text"
          disabled={!singleLocationMode}
          id="facebookTrackingNumber"
          placeholder="Tracking Phone Number"
          maxLength={155}
          value={locationPatch.listingManagementSpecs.providerTrackingNumbers.FACEBOOK || ''}
          onChange={setTrackingNumber}
          className={"form-control text-input" + (!singleLocationMode ? " cursor-not-allowed" : "")}
        />
        {!singleLocationMode && <UncontrolledTooltip target="facebookTrackingNumber">
          Call Tracking Number can only be edited for single locations.
        </UncontrolledTooltip>}
      </div>
    </div>

    <h5 className="content-spacer-top">UTM/Tracking Website URL</h5>
    <div className="row card-spacer-top">
      <div className="col-12">
      <input
        type="text"
        id="facebookTrackingUrl"
        placeholder="Tracking Url"
        maxLength={155}
        value={locationPatch.listingManagementSpecs.providerTrackingWebsiteUrls.FACEBOOK}
        onChange={setTrackingUrl}
        className="form-control text-input"
      />
      </div>
    </div>

    <h5 className="card-spacer-top">Cover Photo</h5>
    <div className="row card-spacer-top">
      {!!locationPatch.facebookListingManagementSpecs.coverPhotoUrl && <div className="col-4 col-sm-4"><div className="img-gallery-item">
        <div className="text-center overflow-hidden">
          <img src={locationPatch.facebookListingManagementSpecs.coverPhotoUrl} style={{"height": "100px"}}/>
        </div>
        <div className="text-center" style={{"marginTop": "3px"}}>
          <a onClick={unsetCoverPhotoUrl} href="javascript:void(0)" style={{textDecoration: 'underline'}}>Remove</a>
        </div>
      </div>
      </div>}
      {!locationPatch.facebookListingManagementSpecs.coverPhotoUrl && <div className="col-4 col-sm-4">
        <div className="img-gallery-item">
          <div className="text-center overflow-hidden">
            <div style={{"height": "91px", "opacity": "0"}}/>{/* Spacer to match height of uploaded images */}
            <button type="button" className="btn btn-secondary" onClick={() => setImageSelectorOpen(true)}>
              <i className="far fa-plus" />
            </button>
          </div>
        </div>
      </div>}
    </div>
    {
      imageSelectorOpen && 
      <UploadGalleryModal 
        title="Select or Upload a Logo Image"
        modalToggle={setImageSelectorOpen} 
        imageSelectedCallback={image => setCoverPhotoUrl(image.url)} 
        minImageWidthPixels={400} 
        minImageHeightPixels={225} 
        maxImageWidthPixels={5000} 
        maxImageHeightPixels={2813}
        galleryApi={reviewBuilderGalleryApi}
      />
    }
  </div>
}

export default BulkLocationEditorFacebook;